<template>
  <div class="loader" v-if="loading">
    <img src="@/assets/images/icons/loader-points.gif" class="loader-img" :class="{  'sm': size ===  'sm'  }"/>
  </div>
</template>

<script>
    export default {
        name: 'Loader',
        props: ['loading', 'size'],
        watch: {
            loading: function (newVal) {
                this.$emit('onLoadingChanged', newVal);
            }
        }
    }
</script>

<style scoped>
  .sm {
    height: 50px;
  }
</style>
